import React, { useEffect } from 'react';
import { NodeProps, Position, Handle } from 'reactflow';
import { useSelector } from 'react-redux';
import { getWorkflows } from 'src/redux/workflows/selectors';
import { store } from 'src/redux/store';
import { setShowNodesType } from 'src/redux/workflows/slice';
import Icon from '../../ui/Icon/Icon';
import './PlusNode.scss';

const PlusNode: React.FC<NodeProps> = ({ id, data, xPos, yPos }) => {
  const workflowsState = useSelector(getWorkflows);

  useEffect(() => {
    const nodes = document.querySelectorAll('.node-content.selected');
    nodes.forEach(node => node.classList.remove('selected'));
    if (nodes.length > 0) {
      nodes[nodes.length - 1].classList.add('selected');
    }
  }, [workflowsState.showNodesType]);

  const handleShowOptions = () => {
    if (!data?.isEditMode) return;

    store.dispatch(setShowNodesType(id));

    if (data?.scrollToPlusNode && xPos !== undefined && yPos !== undefined) {
      data.scrollToPlusNode({ x: xPos, y: yPos });
    }
  };

  return (
    <div className="plusNode relative">
      <div
        className={`node-content ${workflowsState.showNodesType ? 'selected' : ''} w-[32px] h-[32px] surface-elevated flex items-center justify-center ${!data?.isEditMode ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'}`}
        role="presentation"
        onClick={() => handleShowOptions()}
        onKeyDown={() => handleShowOptions()}>
        <Icon
          name="plus"
          width={20}
          height={20}
          className={`trigger-icon ${!data?.isEditMode ? 'opacity-30' : 'opacity-60'}`}
        />
        <div>
          <Handle
            type="source"
            position={Position.Right}
            id={`${id}`}
            style={{
              opacity: '0%',
              left: '0%',
              position: 'absolute',
              width: '1px !important',
              height: '1px !important',
            }}
          />
          <Handle
            type="source"
            position={Position.Left}
            id={`${id}`}
            style={{
              opacity: '0%',
              left: '2%',
              position: 'absolute',
              width: '1px !important',
              height: '1px !important',
            }}
          />
          <Handle
            type="source"
            position={Position.Top}
            id={`${id}`}
            style={{
              opacity: '0%',
              left: '2%',
              position: 'absolute',
              width: '1px !important',
              height: '1px !important',
            }}
          />
          <Handle
            type="source"
            position={Position.Bottom}
            id={`${id}`}
            style={{
              opacity: '0%',
              bottom: '0%',
              position: 'absolute',
              width: '1px !important',
              height: '1px !important',
            }}
          />
          <Handle
            type="target"
            position={Position.Left}
            id={`${id}`}
            style={{
              opacity: '0%',
              left: '2%',
              position: 'absolute',
              width: '1px !important',
              height: '1px !important',
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default PlusNode;
